import React, { useState } from "react";

import { string, func, bool } from "prop-types";

import {
  Button,
  TextFieldGroup,
  SelectListGroup,
  TextAreaGroup,
  Validate,
} from "../../../../common/index";

import { monthOptions, yearOptions, pick } from "../../../../helpers/index";
import Checkbox from "../../../../common/Checkbox/index";

const constraints = {
  fromMonth: {
    presence: { allowEmpty: false },
  },
  fromYear: {
    presence: { allowEmpty: false },
  },
  title: {
    isNotBlank: true,
  },
  companyName: {
    isNotBlank: true,
  },
};

const WorkHistoryForm = (props) => {
  const {
    title,
    companyName,
    fromMonth,
    toMonth,
    fromYear,
    toYear,
    currentlyWorkHere,
    description,
    onChange,
    triggerSave,
    closePopup,
    isEditing,
  } = props;

  const workHistoryInput = pick(props, [
    "title",
    "companyName",
    "fromMonth",
    "toMonth",
    "fromYear",
    "toYear",
    "currentlyWorkHere",
    "description",
  ]);

  const [blurredElements, setBlurredElements] = useState({});
  const setBlurred = (elementName) => {
    setBlurredElements((elements) => ({ ...elements, [elementName]: true }));
  };

  const areDatesFilled =
    blurredElements.fromMonth &&
    blurredElements.fromYear &&
    !currentlyWorkHere &&
    blurredElements.toMonth &&
    blurredElements.toYear;

  const isDateError = (validation) =>
    areDatesFilled &&
    !(validation.toMonth === undefined && validation.toYear === undefined);

  return (
    <Validate constraints={constraints} userInput={workHistoryInput}>
      {({ isValid, validation }) => (
        <div className="p-1 pt-2 d-flex flex-column h-100">
          <h4 className="text-center">
            {isEditing ? "Edit" : "Add"} work history
          </h4>
          <div className="row overflow-auto">
            <div className="col-md-8">
              <div className="form-group">
                <label
                  htmlFor="title"
                  style={{
                    color: `${
                      blurredElements.title && validation.title
                        ? "red"
                        : "inherit"
                    }`,
                  }}
                >
                  Job title*
                </label>
                <TextFieldGroup
                  classes="register_field"
                  value={title}
                  onChange={(e) => {
                    onChange("title", e.target.value);
                  }}
                  onBlur={() => {
                    setBlurred("title");
                  }}
                  validationMessages={blurredElements.title && validation.title}
                  validationMessageIsRed
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="companyName"
                  style={{
                    color: `${
                      blurredElements.companyName && validation.companyName
                        ? "red"
                        : "inherit"
                    }`,
                  }}
                >
                  Company*
                </label>
                <TextFieldGroup
                  classes="register_field"
                  value={companyName}
                  onChange={(e) => {
                    onChange("companyName", e.target.value);
                  }}
                  onBlur={() => {
                    setBlurred("companyName");
                  }}
                  validationMessages={
                    blurredElements.companyName && validation.companyName
                  }
                  validationMessageIsRed
                />
              </div>
              <Checkbox
                value={currentlyWorkHere}
                onClick={(e) => {
                  onChange("currentlyWorkHere", e.target.checked);
                }}
                label={"I currently work here"}
              />
              <div className="row">
                <div
                  className={`col-12 ${
                    currentlyWorkHere ? "col-md-12" : "col-sm-12"
                  }`}
                >
                  <label className="mb-hf">From*</label>
                  <div className="row form-group">
                    <div className="col-6">
                      <SelectListGroup
                        id="workHistoryFromMonth"
                        classes="register_field register_field-dropdown"
                        options={monthOptions}
                        value={fromMonth}
                        onChange={(e) => {
                          onChange("fromMonth", e.target.value);
                          setBlurred("fromMonth");
                        }}
                      />
                    </div>
                    <div className="col-6 pl-0">
                      <SelectListGroup
                        id="workHistoryFromYear"
                        classes="register_field register_field-dropdown"
                        options={yearOptions}
                        value={fromYear}
                        onChange={(e) => {
                          onChange("fromYear", e.target.value);
                          setBlurred("fromYear");
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {!currentlyWorkHere && (
                  <div className="col-12 col-sm-12">
                    <label
                      className="mb-hf"
                      style={{
                        color: `${isDateError(validation) ? "red" : "inherit"}`,
                      }}
                    >
                      To*
                    </label>
                    <div className="row form-group">
                      <div className="col-6">
                        <SelectListGroup
                          id="workHistoryFromMonth"
                          classes="register_field register_field-dropdown"
                          options={monthOptions}
                          value={toMonth}
                          isError={isDateError(validation)}
                          onChange={(e) => {
                            onChange("toMonth", e.target.value);
                            setBlurred("toMonth");
                          }}
                        />
                      </div>
                      <div className="col-6 pl-0">
                        <SelectListGroup
                          id="workHistoryFromYear"
                          classes="register_field register_field-dropdown"
                          options={yearOptions}
                          value={toYear}
                          isError={isDateError(validation)}
                          onChange={(e) => {
                            onChange("toYear", e.target.value);
                            setBlurred("toYear");
                          }}
                        />
                      </div>
                      {isDateError(validation) && (
                        <span
                          className="col-12 fontSize-12"
                          style={{
                            color: "red",
                          }}
                        >
                          End date can’t be before start date
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <TextAreaGroup
                  classes="register_field"
                  value={description}
                  rows={4}
                  onChange={(e) => {
                    onChange("description", e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end w-100 mt-1 ">
            <Button onClick={closePopup} classes="btn btn-outline-dark">
              Cancel
            </Button>
            <Button
              onClick={() => {
                triggerSave();
                closePopup();
              }}
              disabled={!isValid}
              classes="btn btn-primary ml-1"
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Validate>
  );
};

WorkHistoryForm.propTypes = {
  title: string.isRequired,
  companyName: string.isRequired,
  fromMonth: string.isRequired,
  toMonth: string,
  fromYear: string.isRequired,
  toYear: string,
  currentlyWorkHere: bool.isRequired,
  description: string.isRequired,
  onChange: func.isRequired,
  closePopup: func.isRequired,
  triggerSave: func.isRequired,
  isEditing: bool,
};

export default WorkHistoryForm;
